import { motion } from 'framer-motion';
import { useState } from 'react';
import GlobalNavbar from '../../components/feature/GlobalNavbar';
import AdvertiseHero from './components/AdvertiseHero';
import AdvertiseProcess from './components/AdvertiseProcess';
import AdvertisePlans from './components/AdvertisePlans';
import AdvertiseForm from './components/AdvertiseForm';
import AdvertiseFooter from './components/AdvertiseFooter';

export default function AdvertisePage() {
  const [selectedPlan, setSelectedPlan] = useState('');

  return (
    <div className="min-h-screen bg-slate-900 font-inter">
      <GlobalNavbar />
      <AdvertiseHero />
      <AdvertiseProcess />
      <AdvertisePlans onSelectPlan={setSelectedPlan} />
      <AdvertiseForm selectedPlan={selectedPlan} />
      <AdvertiseFooter />
    </div>
  );
}
